import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, Music4, Star, Users, Inbox, Mail, ArrowUpRight } from "lucide-react";
import { adminApi } from "../api";
import { PageHead } from "../components";

const CARDS = [
  { key: "articles_published", label: "PUBLISHED ARTICLES", icon: Newspaper, to: "/admin/editorial", accent: "text-gold-bright" },
  { key: "articles_draft", label: "DRAFT ARTICLES", icon: Newspaper, to: "/admin/editorial", accent: "text-sand" },
  { key: "tracks_published", label: "PUBLISHED MUSIC", icon: Music4, to: "/admin/music", accent: "text-gold-bright" },
  { key: "featured_media", label: "FEATURED MEDIA ACTIVE", icon: Star, to: "/admin/featured", accent: "text-burnt-hover" },
  { key: "team_members", label: "TEAM MEMBERS", icon: Users, to: "/admin/team", accent: "text-tan-light" },
  { key: "inquiries_new", label: "NEW INQUIRIES", icon: Inbox, to: "/admin/inquiries", accent: "text-burnt-hover" },
  { key: "subscribers", label: "NEWSLETTER SUBSCRIBERS", icon: Mail, to: "/admin/newsletter", accent: "text-gold-bright" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <PageHead title="THE OPERATION" sub="What's live on The Cobain Report right now." />
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <Link
            key={c.key} to={c.to}
            data-testid={`dashboard-card-${c.key}`}
            className="group border border-woodborder bg-card/40 hover:bg-cardhover/50 hover:border-tan/30 transition-colors p-5"
          >
            <c.icon size={18} className="text-clay group-hover:text-burnt transition-colors" />
            <p className={`mt-4 font-display text-4xl md:text-5xl ${c.accent}`} data-testid={`dashboard-count-${c.key}`}>
              {stats ? stats[c.key] : "—"}
            </p>
            <p className="mt-2 font-mono text-[9px] tracking-[0.2em] text-clay flex items-center gap-1.5">
              {c.label} <ArrowUpRight size={11} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </p>
          </Link>
        ))}
      </div>
      <div className="mt-10 border border-woodborder bg-card/30 p-6" data-testid="dashboard-quicknote">
        <p className="font-mono text-[10px] tracking-[0.25em] text-tan mb-3">OPERATOR NOTES</p>
        <ul className="space-y-2 text-sm text-sand font-light">
          <li>— Publish an article in <span className="text-cream">Editorial</span> and it appears on the public site immediately.</li>
          <li>— Upload an MP4 in <span className="text-cream">Music</span> and it goes live in the public player on publish.</li>
          <li>— <span className="text-cream">Latest / YouTube</span> pulls the newest episode from the channel automatically, every hour.</li>
          <li>— New inquiries and newsletter subscribers land here in real time.</li>
        </ul>
      </div>
    </div>
  );
}
